import './SortOrderButton.scss';

import { ReactComponent as ArrowIcon } from 'images/icons/SortingArrow.svg';

type SortOrderButtonProps = {
  isActive: boolean;
  sortOrder?: 'ASCENDING' | 'DESCENDING';
  onSortChange: (order: 'ASCENDING' | 'DESCENDING') => void;
};

const SortOrderButton = ({ isActive, sortOrder = 'ASCENDING', onSortChange }: SortOrderButtonProps) => {
  const handleSort = () => {
    const newOrder = isActive && sortOrder === 'ASCENDING' ? 'DESCENDING' : 'ASCENDING';
    onSortChange(newOrder);
  };

  const classNames = `styled-button sort-button ${isActive ? (sortOrder === 'ASCENDING' ? 'ascending' : 'descending') : ''} ${
    isActive ? 'active' : ''
  }`;

  return (
    <button onClick={handleSort} className={classNames}>
      <ArrowIcon />
    </button>
  );
};

export default SortOrderButton;
